import { render, staticRenderFns } from "./storage-locations-editor.vue?vue&type=template&id=44d8baec&"
import script from "./storage-locations-editor.vue?vue&type=script&lang=js&"
export * from "./storage-locations-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports